
import { TowerType, EnemyType, TowerStats, EnemyStats, Point, Slot, Mission, ThemeType } from './types';

export const GAME_WIDTH = 1000;
export const GAME_HEIGHT = 700;

export const TOWER_STATS: Record<TowerType, TowerStats> = {
  [TowerType.ARCHER]: { cost: 70, range: 170, damage: 14, cooldown: 850, color: '#8B4513' },
  [TowerType.BARRACKS]: { cost: 100, range: 110, damage: 8, cooldown: 1800, color: '#4682B4' },
  [TowerType.MAGE]: { cost: 125, range: 150, damage: 28, cooldown: 2100, color: '#9370DB' },
  [TowerType.ARTILLERY]: { cost: 180, range: 200, damage: 55, cooldown: 4500, color: '#2F4F4F' }
};

export const ENEMY_STATS: Record<EnemyType, EnemyStats> = {
  [EnemyType.ORC]: { health: 70, speed: 0.45, reward: 18, color: '#4d7c2c', size: 15 },
  [EnemyType.WOLF]: { health: 35, speed: 1.1, reward: 12, color: '#8e8e8e', size: 11 },
  [EnemyType.SHAMAN]: { health: 90, speed: 0.35, reward: 45, color: '#c54242', size: 17 },
  [EnemyType.BOSS]: { health: 3000, speed: 0.22, reward: 600, color: '#2b2b2b', size: 40 }
};

export const THEME_DATA: Record<ThemeType, { bg: string, path: string, pathEdge: string }> = {
  [ThemeType.FOREST]: { bg: '#4b7d32', path: '#d9c58c', pathEdge: '#c9b57c' },
  [ThemeType.DESERT]: { bg: '#d4a373', path: '#fefae0', pathEdge: '#faedcd' },
  [ThemeType.SNOW]: { bg: '#e0fbfc', path: '#98c1d9', pathEdge: '#3d5a80' },
  [ThemeType.CAVE]: { bg: '#2b2d42', path: '#8d99ae', pathEdge: '#4a4e69' },
  [ThemeType.VOLCANO]: { bg: '#370617', path: '#9d0208', pathEdge: '#6a040f' },
  [ThemeType.WASTELAND]: { bg: '#332c23', path: '#433d3c', pathEdge: '#2a2524' }
};

// Level Generator for 30 levels
export const MISSIONS: Mission[] = Array.from({ length: 30 }).map((_, i) => {
  const id = i + 1;
  const themeIdx = Math.floor(i / 5);
  const themes = [ThemeType.FOREST, ThemeType.DESERT, ThemeType.SNOW, ThemeType.CAVE, ThemeType.VOLCANO, ThemeType.WASTELAND];
  const theme = themes[themeIdx];

  // Variations in path based on level ID to ensure uniqueness
  const path: Point[] = [
    { x: -50, y: 350 + Math.sin(id) * 100 },
    { x: 200, y: 350 + Math.sin(id) * 100 },
    { x: 200 + Math.cos(id) * 50, y: 150 + Math.abs(Math.sin(id * 2)) * 100 },
    { x: 450, y: 150 + Math.abs(Math.sin(id * 2)) * 100 },
    { x: 450 + Math.sin(id) * 50, y: 550 - Math.abs(Math.cos(id)) * 100 },
    { x: 750, y: 550 - Math.abs(Math.cos(id)) * 100 },
    { x: 750 + Math.sin(id * 3) * 50, y: 350 },
    { x: 1050, y: 350 }
  ];

  const slots: Slot[] = [
    { x: 100, y: 260, isLocked: false, unlockCost: 0 },
    { x: 300, y: 220, isLocked: false, unlockCost: 0 },
    { x: 350, y: 460, isLocked: false, unlockCost: 0 },
    { x: 850, y: 260, isLocked: false, unlockCost: 0 },
    { x: 150, y: 500, isLocked: false, unlockCost: 0 },
    { x: 720, y: 550, isLocked: false, unlockCost: 0 },
    { x: 800, y: 420, isLocked: false, unlockCost: 0 },
    // Locked ones
    { x: 550, y: 180, isLocked: true, unlockCost: 300 + i * 20 },
    { x: 650, y: 460, isLocked: true, unlockCost: 450 + i * 25 },
    { x: 650, y: 260, isLocked: true, unlockCost: 600 + i * 30 },
    { x: 450, y: 300, isLocked: true, unlockCost: 800 + i * 40 },
    { x: 220, y: 600, isLocked: true, unlockCost: 1000 + i * 50 }
  ];

  return { id, theme, path, slots, waves: 20 };
});

export const MAGE_SLOW_FACTOR = 0.5;
export const MAGE_SLOW_DURATION = 3000;
export const ARTILLERY_SPLASH_RADIUS = 90;
